import axios from "axios";
import dayjs from "dayjs";
import { IOperationStatus } from "types";
import formatDate from "utils/formatDate";

axios.defaults.headers.common["token"] = "3abd7f83-aae7-48fd-a4e5-77f19689921a";

export const downloadSummaryReport = async (
  date_from: Date,
  date_to: Date,
  by_date: string,
  hotelIds?: string[],
) => {
  return axios
    .request({
      url: `${
        process.env.REACT_APP_API_URL
      }/dashboard/download/summary-report?date_from=${formatDate(
        date_from,
      )}&date_to=${formatDate(
        dayjs(date_to).add(1, "day"),
      )}&by_date=${by_date}&hotelIds=${hotelIds ? hotelIds.join(",") : ""}`,
      method: "GET",
      responseType: "blob",
      headers: { Authorization: `Bearer ${localStorage.ldapToken}` },
    })
    .then((response) => response.data);
};

export const getUserHotels = async () => {
  const route = `${process.env.REACT_APP_API_URL}/users/authed/hotels`;
  try {
    const response = await axios.get(route);
    return response.data;
  } catch (err: any) {
    console.error(`get user hotels err: ${err}`);
    return [];
  }
};

export const getDashboardConfigBatch = async (hotelIds: string[]) => {
  if (!hotelIds || hotelIds.length === 0) return {};
  const route = `${process.env.REACT_APP_API_URL}/dashboard/config-batch?hotelIds=${hotelIds.join(",")}`;
  try {
    const response = await axios.get(route);
    return response.data; // Expected format: { "hotel1": config, "hotel2": config }
  } catch (err: any) {
    console.error(`get dashboard config batch err: ${err}`);
    return {};
  }
};

export const downloadDetailReport = async (
  date_from: Date,
  date_to: Date,
  by_date: string,
  hotelIds?: string[],
) => {
  return axios
    .request({
      url: `${
        process.env.REACT_APP_API_URL
      }/dashboard/download/detail-report?date_from=${formatDate(
        date_from,
      )}&date_to=${formatDate(
        dayjs(date_to).add(1, "day"),
      )}&by_date=${by_date}&hotelIds=${hotelIds ? hotelIds.join(",") : ""}`,
      method: "GET",
      responseType: "blob",
      headers: { Authorization: `Bearer ${localStorage.ldapToken}` },
    })
    .then((response) => response.data);
};

export const getAllOperationStatus = async () => {
  const route = `${process.env.REACT_APP_API_URL}/configurations/operationstatus`;

  return axios
    .request({
      url: route,
      method: "GET",
      headers: { Authorization: `Bearer ${localStorage.ldapToken}` },
    })
    .then((response) => response.data);
};

export const updateOperationStatus = async (body: IOperationStatus) => {
  const route = `${process.env.REACT_APP_API_URL}/configurations/operationstatus`;
  try {
    const response = (
      await axios.put(route, body, {
        headers: {
          Authorization: `Bearer ${localStorage.ldapToken}`,
        },
      })
    ).data;
    return response;
  } catch (err: any) {
    console.error(`update all OperationStatus err: ${err}`);
    throw err.response?.data;
  }
};

export const changePassword = async (body: {
  username: string;
  originalPassword: string;
  newPassword: string;
}) => {
  return axios.patch(
    `${process.env.REACT_APP_API_URL}/dashboard/change-password`,
    body,
    { headers: { Authorization: `Bearer ${localStorage.ldapToken}` } },
  );
};
